function performFlipAnimation(el, stateClass, animationClass) {
    const first = el.getBoundingClientRect();
    el.classList.toggle(stateClass);
    const last = el.getBoundingClientRect();

    const invert = {
        x: first.left - last.left,
        y: first.top - last.top,
        sx: first.width / last.width,
        sy: first.height / last.height
    };

    el.style.transformOrigin = '0 0';
    el.style.transform = `translate(${invert.x}px, ${invert.y}px) scale(${invert.sx}, ${invert.sy})`;

    requestAnimationFrame(() => {
      el.classList.add(animationClass);
      el.style.transform = '';
    });

    const removeAnimationClass = () => {
        el.classList.remove(animationClass);
        el.removeEventListener('transitionend', removeAnimationClass);
    };

    el.addEventListener('transitionend', removeAnimationClass);
}

export default performFlipAnimation;



// WEBPACK FOOTER //
// ./src/animation.js